import { render, staticRenderFns } from "./UpdateCustomer.vue?vue&type=template&id=32336d84&scoped=true&"
import script from "./UpdateCustomer.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomer.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomer.vue?vue&type=style&index=0&id=32336d84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32336d84",
  null
  
)

export default component.exports
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QExpansionItem,QForm,QInput,QBtn,QIcon,QList,QItem,QItemSection,QDialog});
